import { useContext } from 'react';
import CrmContext, { ICrmContext } from '../contexts/CrmContext';

const useCrm = (): ICrmContext => useContext(CrmContext);

export default useCrm;
